/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Suggestion_Accept_AllInputs */



/**
* | output |
* | --- |
* | "Accept All" |
*
* @param {Editor_Suggestion_Accept_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_suggestion_accept_all = /** @type {((inputs?: Editor_Suggestion_Accept_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Suggestion_Accept_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle annehmen")
	return /** @type {LocalizedString} */ ("Accept All")
});